export default __webpack_public_path__ + "files/thumbnail-3de5eb31da87c78258f100b3bb4216ff.png";